exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge.badge-payment-date {\n  font-size: 16px;\n  border-radius: 10px;\n}\n.table.table-payment {\n  margin: 10px auto;\n}\n.table.table-payment td {\n  border-bottom: 1px solid #dee2e6;\n  background-color: #f0f0f0;\n}\n.table.table-payment td:nth-child(1) {\n  font-weight: bold;\n}", ""]);

// exports
